import { eventCategories } from "@/mocks/events";

export default function Events() {
  return (
    <section
      id="events"
      className="w-full bg-background-100 py-10 md:py-12 lg:py-14"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-8 md:mb-10">
          <p className="text-xs font-semibold tracking-widest uppercase text-primary-600 mb-4">
            Industry Engagement
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            Events &amp; Global Engagement
          </h2>
          <p className="mt-4 text-base md:text-lg text-foreground-700 max-w-3xl mx-auto leading-relaxed">
            A&amp;J brings industry stakeholders together through conferences,
            forums, exhibitions, competitions and international delegations,
            creating meaningful connections across the global textile ecosystem.
          </p>
        </div>

        {/* Categories Strip */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-4 md:gap-5 mb-8 md:mb-10">
          {eventCategories.map((cat) => (
            <div
              key={cat.name}
              className="flex flex-col items-center text-center bg-background-50 border border-background-200/70 rounded-lg p-5 hover:border-primary-300/60 transition-colors"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                <i className={`${cat.icon} text-xl`} />
              </div>
              <span className="text-sm font-semibold text-foreground-800">
                {cat.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}